import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

const booleanEnvValue = z.preprocess((value) => {
  if (typeof value === 'boolean') {
    return value
  }

  if (typeof value === 'string') {
    const normalizedValue = value.trim().toLowerCase()

    if (normalizedValue === 'true' || normalizedValue === '1') {
      return true
    }

    if (normalizedValue === 'false' || normalizedValue === '0') {
      return false
    }
  }

  return value
}, z.boolean())

export const env = createEnv({
  server: {
    SERVER_URL: z.string().url().optional(), // unused
  },

  /**
   * The prefix that client-side variables must have. This is enforced both at
   * a type-level and at runtime.
   */
  clientPrefix: 'VITE_',

  client: {
    VITE_API_URL: z.string(),
    VITE_APP_DOMAIN: z.string().min(1),
    VITE_APP_TITLE: z.string().min(1),
    VITE_GRAPHQL_URL: z.string(),
    VITE_PRESENCE_ENABLED: booleanEnvValue.default(true),
    VITE_PRESENCE_HEARTBEAT_MS: z.coerce.number().min(1).optional(),
    VITE_FARO_URL: z.string().min(1).optional(),
  },

  /**
   * What object holds the environment variables at runtime. This is usually
   * `process.env` or `import.meta.env`.
   */
  runtimeEnv: import.meta.env,

  /**
   * By default, this library will feed the environment variables directly to
   * the Zod validator.
   *
   * This means that if you have an empty string for a value that is supposed
   * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
   * it as a type mismatch violation. Additionally, if you have an empty string
   * for a value that is supposed to be a string with a default value (e.g.
   * `DOMAIN=` in a ".env" file), the default value will never be applied.
   *
   * In order to solve these issues, we recommend that all new projects
   * explicitly specify this option as true.
   */
  emptyStringAsUndefined: true,
})
